
import { Vue, Component } from 'vue-property-decorator';
import ShowEventDotMock from '@/ui/components/devices/previews/components/ShowEventDotMock.vue';
import InputFieldMock from '@/ui/components/devices/previews/components/InputFieldMock.vue';
import SwitchMock from '@/ui/components/devices/previews/components/SwitchMock.vue';
import DeviceLayout from '@/ui/components/devices/components/DeviceLayout.vue';

@Component({
  components: {
    ShowEventDotMock,
    InputFieldMock,
    SwitchMock,
    DeviceLayout,
  },
})
export default class ThermostatAnalogPreview extends Vue {
  get mainViewLang() {
    return 'devices.ThermostatAnalog.mainView';
  }
  get settingsViewLang() {
    return 'devices.ThermostatAnalog.settingsView';
  }
  get previewNameLang() {
    return this.$t('devices.ThermostatAnalog.previewName');
  }
}
